import {
  AcceptType,
  ContentType,
  getRequest,
  postRequest,
} from '../../../utils/apiUtils';

export const getWithdrawalList = (params: CapBayGetParams) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.WithdrawalData[]>>
  >('/p2p-admin/withdrawal/list', params);
};

export const getDepositList = (params: CapBayGetParams) => {
  return postRequest<CapBayApiData<investors.DepositListResponse>>(
    '/p2p-admin/deposit/list',
    params,
  );
};

export const postDepositUpdate = (
  requestBody: investors.DepositUpdateRequestBody,
) => {
  return postRequest('/p2p-admin/deposit/update', requestBody);
};

interface GetDepositDocumentListParams {
  paymentDetailICNId: string | number;
}

export const getDepositDocumentList = (
  params: GetDepositDocumentListParams,
) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.DepositDocsData[]>>
  >('/p2p-admin/deposit/document', params);
};

interface GetDownloadDepositDocumentParam {
  fileId: string;
  fileToken: string;
}

export const getDownloadDepositDocument = (
  params: GetDownloadDepositDocumentParam,
) => {
  return postRequest<Blob>('/p2p-admin/deposit/document/download', params, {
    responseType: 'blob',
    acceptType: AcceptType.JSON,
    contentType: ContentType.JSON,
  });
};

export const postUploadDepositDocument = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.UploadDepositDocumentResp>>(
    '/p2p-admin/deposit/document/create',
    payload,
  );
};

export const postDeleteDepositDocument = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.DeleteDepositDocumentResp>>(
    '/p2p-admin/deposit/document/delete',
    payload,
  );
};

export const postDepositVerify = (
  requestBody: investors.DepositVerifyRequestBody,
) => {
  return postRequest<CapBayApiData<investors.DepositVerityResponseBody>>(
    '/p2p-admin/deposit/verify',
    requestBody,
  );
};

export const postWithdrawalVerify = (
  requestBody: investors.WithdrawalVerifyRequestBody,
) => {
  return postRequest<CapBayApiData<investors.WithdrawalVerifyResponseBody>>(
    '/p2p-admin/withdrawal/verify',
    requestBody,
  );
};

// completed users

export const getCompletedInvestorList = (
  payload: investors.InvestorListFilterData,
) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.InvestorListData[]>>
  >('/p2p-admin/investor', payload);
};

export const postUpdateStatus = (payload: investors.UpdateStatusPayload) => {
  return postRequest<CapBayApiData<investors.UpdateStatusResponse>>(
    '/p2p-admin/investor/update-status',
    payload,
  );
};

export const postUpdateEmailVerification = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.UpdateStatusResponse>>(
    '/p2p-admin/investor/update-email-verification',
    payload,
  );
};

export const postUpdateKYCVerification = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.UpdateKYCVerficationResponse>>(
    '/p2p-admin/investor/update-kyc-verification',
    payload,
  );
};

export const getCompletedInvestorDetails = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.InvestorDetails>>(
    '/p2p-admin/investor/details',
    payload,
  );
};

export const getAddEditInvestorOptions = () => {
  return getRequest<CapBayApiData<investors.AddEditInvestorOptions>>(
    '/p2p-admin/investor/add-investor-modal',
  );
};

export const getEditInvestorDetails = (
  payload: investors.EditInvestorDetailsParam,
) => {
  return postRequest<CapBayApiData<investors.InvestorDetails>>(
    '/p2p-admin/investor/edit',
    payload,
  );
};

export const postGetInvestorTin = (
  payload: investors.GetInvestorTinPayload,
) => postRequest<CapBayApiData<investors.GetInvestorTinResponse>>(
  '/p2p-admin/investor/get-investor-tin',
  payload,
);

export const postGetValidatedInvestorTin = (
  payload: investors.GetValidatedInvestorTinPayload,
) => postRequest<CapBayApiData<investors.GetInvestorTinResponse>>(
  '/p2p-admin/investor/get-validated-investor-tin',
  payload,
);

export const postUpdateInvestor = (payload: investors.EditInvestorApiPayload) => {
  return postRequest<CapBayApiData<investors.UpdateStatusResponse>>(
    '/p2p-admin/investor/update',
    payload,
  );
};

export const postAddInvestor = (payload: investors.AddInvestorApiPayload) => {
  return postRequest<CapBayApiData<investors.InvestorListData>>(
    '/p2p-admin/investor/add',
    payload,
  );
};

export const postDeleteInvestor = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.UpdateStatusResponse>>(
    '/p2p-admin/investor/delete',
    payload,
  );
};

export const postResetPassword = (payload: FormData) => {
  return postRequest('/p2p-admin/investor/reset-password', payload);
};

export const postGenerateKyc = (payload: FormData) => {
  return postRequest('/p2p-admin/investor/kyc/generate', payload);
};

export const postUploadExcelInvestorList = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.UploadMultipleCapbayUsersResp>>('/p2p-admin/investor/upload-excel', payload);
};

export const getDownloadInvestorList = () => {
  return getRequest<Blob>('/p2p-admin/investor/download-investor-list', null, {
    acceptType: AcceptType.JSON,
    contentType: ContentType.JSON,
    responseType: 'blob',
  });
};

export const getInvestorCompanyList = (payload: FormData) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.InvestorCompanyData[]>>
  >('/p2p-admin/investor/companies', payload);
};

export const getCompanyModalOptions = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.CompanyModalOptions>>(
    '/p2p-admin/investor/companies/modal',
    payload,
  );
};

export const postAddInvestorCompany = (payload: FormData) => {
  return postRequest('/p2p-admin/investor/companies/add', payload);
};

export const getInvestorBankAccountList = (payload: FormData) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.BankAccountData[]>>
  >('/p2p-admin/investor/account-bank', payload);
};

export const getBankAccountModalOptions = () => {
  return getRequest<CapBayApiData<investors.BankAccountModalOptions>>(
    '/p2p-admin/investor/account-bank/modal',
  );
};

export const postAddBankAccount = (payload: FormData) => {
  return postRequest('/p2p-admin/investor/account-bank/add', payload);
};

export const postUpdateBankAccount = (payload: FormData) => {
  return postRequest('/p2p-admin/investor/account-bank/update', payload);
};

export const postDeleteBankAccount = (payload: FormData) => {
  return postRequest('/p2p-admin/investor/account-bank/delete', payload);
};

export const getInvestorAddressList = (payload: FormData) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.AddressData[]>>>(
    '/p2p-admin/investor/address',
    payload,
  );
};

export const getInvestorAddressModalOptions = () => {
  return getRequest<CapBayApiData<investors.AddressModalOptions>>(
    '/p2p-admin/investor/address/modal',
  );
};

export const postAddAddress = (payload: investors.AddAddressPayload) => {
  return postRequest('/p2p-admin/investor/address/add', payload);
};

export const getEditAddressData = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.AddressData>>(
    '/p2p-admin/investor/address/edit',
    payload,
  );
};

export const postUpdateAddress = (payload: investors.EditAddressPayload) => {
  return postRequest('/p2p-admin/investor/address/update', payload);
};

export const postDeleteAddress = (payload: FormData) => {
  return postRequest('/p2p-admin/investor/address/delete', payload);
};

export const getInvestorDocumentList = (payload: FormData) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.DocumentData[]>>
  >('/p2p-admin/investor/documents', payload);
};

export const postDeleteDocument = (payload: FormData) => {
  return postRequest('/p2p-admin/investor/documents/delete', payload);
};

export const postDownloadDocument = (payload: FormData) => {
  return postRequest<Blob>('/p2p-admin/investor/documents/download', payload, {
    contentType: ContentType.JSON,
    acceptType: AcceptType.JSON,
    responseType: 'blob',
  });
};

export const postUploadDocument = (payload: FormData) => {
  return postRequest('/p2p-admin/investor/documents/upload', payload);
};

export const getDocumentModalOptions = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.DocumentModalOptions>>(
    '/p2p-admin/investor/documents/upload-document-modal',
    payload,
  );
};

export const getInvestorRoleList = (payload: FormData) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.RoleData[]>>>(
    '/p2p-admin/investor/role',
    payload,
  );
};

export const getInvestorEkyc = (payload: FormData) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.EKYCData[]>>>(
    '/p2p-admin/investor/ekyc',
    payload,
  );
};

export const getInvestorAgreementList = (payload: FormData) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.AgreementData[]>>
  >('/p2p-admin/investor/agreements', payload);
};

export const postDownloadAgreement = (payload: FormData) => {
  return postRequest<Blob>('/p2p-admin/investor/agreements/download', payload, {
    acceptType: AcceptType.JSON,
    contentType: ContentType.JSON,
    responseType: 'blob',
  });
};

export const postUpdateAgreementDate = (payload: investors.EditAgreementDatePayload) => {
  return postRequest('/p2p-admin/investor/agreements/update', payload);
};

export const getInvestorKYCList = (payload: FormData) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.KYCData[]>>>(
    '/p2p-admin/investor/kyc',
    payload,
  );
};

export const getKycModalOptions = () => {
  return getRequest<CapBayApiData<investors.KycModalOptions>>(
    '/p2p-admin/investor/kyc/modal',
  );
};

export const postUpdateKyc = (payload: FormData) => {
  return postRequest('/p2p-admin/investor/kyc/update', payload);
};

export const postKycReport = (payload: FormData) => {
  return postRequest<string>('/p2p-admin/investor/kyc/report', payload);
};

export const getInvestorDeactivationRecord = (
  payload: investors.GetInvestorDeactivationRecordParams,
) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.DeactivationRecordData[]>>>('/p2p-admin/investor/deactivation-record', payload);
};

export const getDeactivateReasons = () => {
  return getRequest<CapBayApiData<Inputs.SelectOption[]>>('/p2p-admin/investor/deactivate-reasons');
};

export const postResendActivationEmail = (
  payload: investors.ResendActivationEmailPayload,
) => {
  return postRequest('/p2p-admin/investor/resend-activation-email', payload);
};

export const getInvestorAdTracking = (payload: FormData) => {
  return postRequest<CapBayApiData>(
    '/p2p-admin/investor/ad-tracking',
    payload,
  );
};

export const getInvestorNote = (payload: investors.GetInvestorNoteParam) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.NoteData[]>>>(
    '/p2p-admin/investor/note', payload,
  );
};

export const getInvestorNoteHistories = (payload: investors.GetInvestorNoteParam) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.NoteData[]>>>(
    '/p2p-admin/investor/note/history', payload,
  );
};

export const postAddInvestorNote = (payload: investors.PostAddInvestorNotePayload) => {
  return postRequest<CapBayApiData<investors.AddInvestorNoteResponse>>(
    '/p2p-admin/investor/note/add', payload,
  );
};

export const postUpdateInvestorNote = (payload: investors.UpdateInvestorNotePayload) => {
  return postRequest<CapBayApiData<investors.UpdateInvestorNoteResponse>>(
    '/p2p-admin/investor/note/update', payload,
  );
};

export const postDeleteInvestorNote = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.DeleteInvestorNoteResponse>>(
    '/p2p-admin/investor/note/delete', payload,
  );
};

export const getAutoInvestStatusHistories = (payload: investors.GetAutoInvestStatusParam) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.autoInvestStatusData[]>>>(
    '/p2p-admin/investor/auto-invest-status-history', payload,
  );
};

// investor recorder

export const postInvestorRecorderList = (params: CapBayGetParams) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.InvestorRecorderData[]>>
  >('/p2p-admin/investor-recorder/list', params);
};

export const getInvestorRecorderSummaryDetail = (
  requestBody: investors.GetInvestorRecorderDetailRequestBody,
) => {
  return getRequest<CapBayApiData<investors.InvestorRecorderSummaryDetails>>(
    `/p2p-admin/investor-recorder/summary-detail/${requestBody.id}`,
  );
};

export const getInvestorRecorderPerformanceDetails = (
  requestBody: investors.GetInvestorRecorderDetailRequestBody,
) => {
  return getRequest<CapBayApiData<investors.InvestorRecorderPerformanceDetails>>(
    `/p2p-admin/investor-recorder/performance-detail/${requestBody.id}`,
  );
};

export const getInvestorRecorderTransactionList = (
  requestBody: investors.GetInvestorRecorderDetailRequestBody,
) => {
  return getRequest<CapBayApiData<investors.InvestorRecorderTransactionList>>(
    `/p2p-admin/investor-recorder/transaction-list/${requestBody.id}`,
  );
};

export const getInvestorRecorderAllocationFilterOptions = () => {
  return getRequest<CapBayApiData<investors.InvestorRecorderAllocationFilterOptions>>(
    '/p2p-admin/investor-recorder/investment-allocations/filter-options',
  );
};

export const getInvestorRecorderAllocationList = (
  payload: investors.InvestorRecorderAllocationFilter,
) => {
  return getRequest<CapBayApiData<investors.InvestorRecorderAllocationTabularData>>(
    '/p2p-admin/investor-recorder/investment-allocations',
    payload,
  );
};

export const exportInvestmentAllocationList = (
  payload: investors.InvestorRecorderAllocationFilter,
) => {
  return postRequest<Blob>('/p2p-admin/investor-recorder/investment-allocations/export',
    payload,
    {
      acceptType: AcceptType.JSON,
      contentType: ContentType.JSON,
      responseType: 'blob',
    });
};

export const postUpdateInvestorPortfolioType = (payload: investors.UpdatePortfolioTypePayload) => {
  return postRequest<investors.GetCapbayUserListResp>(
    '/p2p-admin/investor-recorder/update-portfolio-type',
    payload,
  );
};

export const getInvestorCategoryFilterOptions = () => {
  return getRequest<CapBayApiData<investors.InvestorCategoryFilterOptions>>('/p2p-admin/investor-recorder/filter-options');
};

export const postUpdateInvestorAllocationLimit = (payload: investors.UpdateInvestorAllocationLimitProps) => {
  return postRequest<investors.UpdateAllocationLimitResp>(
    '/p2p-admin/investor-recorder/update-allocation-limit',
    payload,
  );
};

export const postUpdateHasAllocationLimit = (payload: investors.UpdateHasAllocationLimitProps) => {
  return postRequest<investors.UpdateHasAllocationLimitResp>(
    '/p2p-admin/investor-recorder/update-has-allocation-limit',
    payload,
  );
};

// interested user

export const getInterestedUserList = (payload: CapBayGetParams) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.InterestedUserData[]>>
  >('/p2p-admin/interested-user', payload);
};

export const getInterestedUserDetails = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.InvestorDetails>>(
    '/p2p-admin/interested-user/detail',
    payload,
  );
};

export const getInterestedUserAddress = (payload: FormData) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.AddressData[]>>>(
    '/p2p-admin/interested-user/address',
    payload,
  );
};

export const getInterestedUserDocuments = (payload: FormData) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.DocumentData[]>>
  >('/p2p-admin/interested-user/document', payload);
};

export const getInterestedUserEKYC = (payload: FormData) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.EKYCData[]>>>(
    '/p2p-admin/interested-user/ekyc',
    payload,
  );
};

export const postDownloadUserInterestedDocument = (payload: FormData) => {
  return postRequest<Blob>(
    '/p2p-admin/interested-user/document/download',
    payload,
    {
      contentType: ContentType.JSON,
      acceptType: AcceptType.JSON,
      responseType: 'blob',
    },
  );
};

export const postDeleteUserInterested = (payload: investors.DeleteInterestedUserPayload) => {
  return postRequest('/p2p-admin/interested-user/delete', payload);
};

export const getInterestedUserAdTracking = (payload: FormData) => {
  return postRequest<CapBayApiData>(
    '/p2p-admin/interested-user/ad-tracking',
    payload,
  );
};

export const exportUserInterestedList = () => {
  return getRequest<Blob>('/p2p-admin/interested-user/export', null, {
    acceptType: AcceptType.JSON,
    contentType: ContentType.JSON,
    responseType: 'blob',
  });
};

export const getDepositFormOptions = (payload: investors.GetDepositFormOptionsParam) => {
  return postRequest<CapBayApiData<investors.GetDepositFormOptionsResp>>(
    '/p2p-admin/deposit/create/form-options',
    payload,
  );
};

export const createDeposit = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.CreateDepositResp>>(
    '/p2p-admin/deposit/create',
    payload,
  );
};

export const postResendUnregisteredBankEmail = (
  payload: investors.ResendUnregisteredBankEmailPayload,
) => {
  return postRequest('/p2p-admin/deposit/resend-unregistered-bank-email', payload);
};

export const getWithdrawalFormOptions = (payload: investors.GetWithdrawalFormOptionsParam) => {
  return postRequest<CapBayApiData<investors.GetWithdrawalFormOptionsResp>>(
    '/p2p-admin/withdrawal/create/form-options',
    payload,
  );
};

export const createWithdrawal = (payload: investors.CreateWithdrawalParam) => {
  return postRequest<CapBayApiData<investors.CreateWithdrawalResp>>(
    '/p2p-admin/withdrawal/create',
    payload,
  );
};

export const getFundInvestorList = (payload: investors.GetFundInvestorListParam) => {
  return postRequest<investors.GetFundInvestorListResp>(
    '/p2p-admin/fund/investor-list',
    payload,
  );
};

export const getCapbayUserList = (payload: investors.GetCapbayUserListParam) => {
  return postRequest<investors.GetCapbayUserListResp>(
    '/p2p-admin/manage-users/list',
    payload,
  );
};

export const postDeleteCapbayUser = (payload: investors.DeleteCapbayUserPayload) => {
  return postRequest<CapBayApiData>(
    '/p2p-admin/manage-users/delete',
    payload,
  );
};

export const getUnassociatedUserList = () => {
  return postRequest<CapBayApiData<investors.GetUnassociatedUserListResp>>(
    '/p2p-admin/manage-users/get-unassociated-users',
  );
};

export const postAddCapbayUser = (payload: investors.AddCapbayUserPayload) => {
  return postRequest<CapBayApiData>(
    '/p2p-admin/manage-users/add-capbay-user',
    payload,
  );
};

export const getMultipleCapbayUsersExcelTemplate = () => {
  return postRequest<BlobPart>('/p2p-admin/manage-users/download-template', {}, {
    responseType: 'blob',
    acceptType: AcceptType.JSON,
    contentType: ContentType.JSON,
  });
};

export const postUploadMultipleCapbayUsers = (payload: FormData) => {
  return postRequest<investors.UploadMultipleCapbayUsersResp>(
    '/p2p-admin/manage-users/upload-multiple-capbay-users',
    payload,
  );
};

// platinum investor monthly email

export const getPlatinumInvestorList = (payload: CapBayGetParams) => {
  return postRequest<
    CapBayApiData<CapBayTabularData<investors.PlatinumInvestorListData[]>>
  >('/p2p-admin/platinum-investor', payload);
};

export const getSendPlatinumInvestorMonthlyEmailOptions = (params: investors.GetPlatinumInvestorEmailOptionsPayload) => {
  return getRequest<CapBayApiData<investors.PlatinumInvestorEmailRecipientOptions>>(
    '/p2p-admin/platinum-investor/send-email-options', params,
  );
};

export const postSendPlatinumInvestorMonthlyEmail = (params: investors.SendPlatinumInvestorMonthlyEmailPayload) => {
  return postRequest<CapBayApiData<Inputs.SelectOption[]>>('/p2p-admin/platinum-investor/send-monthly-email', params);
};

/* Service Fee Rebate */
export const getServiceFeeRebateFilter = () => {
  return getRequest<CapBayApiData<investors.GetServiceFeeRebateFilterOptions>>(
    '/p2p-admin/service-fee-rebate/options/investor-filter',
  );
};

export const getServiceFeeRebateTypeOptions = () => {
  return getRequest<CapBayApiData<Inputs.SelectOption[]>>(
    '/p2p-admin/service-fee-rebate/options/rebate-types',
  );
};

export const getRebateOptionsByRebateType = (rebateTypeId?: number | null) => {
  return getRequest<CapBayApiData<investors.GetDropdownByRebateTypeOptions>>(
    '/p2p-admin/service-fee-rebate/options/rebate-options',
    { rebateTypeId },
  );
};

export const getRebateOptionsByInvestmentNote = (investmentNoteId?: number | null) => {
  return getRequest<CapBayApiData<investors.GetDropdownByRebateInvestmentNoteOptions>>(
    '/p2p-admin/service-fee-rebate/options/investment-note-options',
    { investmentNoteId },
  );
};

export const exportServiceFeeRebateEligibility = (payload: investors.ExportServiceFeeRebateEligibility) => {
  return postRequest<CapBayApiData<investors.ExportRebateEligibilityResponse>>('/p2p-admin/service-fee-rebate/export-rebate-eligibility', payload);
};

export const getServiceFeeRebateInvestorList = (payload: investors.GetServiceFeeRebateInvestorList) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.ServiceFeeRebateInvestorData[]>>>(
    '/p2p-admin/service-fee-rebate/list-investors',
    payload,
  );
};

export const postAddRebateEligibility = (payload: investors.NewRebateEligibilityForm) => {
  return postRequest<CapBayApiData<investors.UpdateRebateEligibilityResponse>>(
    '/p2p-admin/service-fee-rebate/add-rebate-eligibility',
    payload,
  );
};

export const getInvestorRebateEligibilityList = (payload: investors.InvestorRebateEligibilityDetails) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.InvestorRebateEligibilityData[]>>>(
    '/p2p-admin/service-fee-rebate/investor-rebate-details',
    payload,
  );
};

export const postEditRebateEligibility = (payload: investors.EditRebateEligibilityForm) => {
  return postRequest<investors.UpdateRebateEligibilityResponse>(
    '/p2p-admin/service-fee-rebate/edit-rebate-eligibility',
    payload,
  );
};

export const downloadRebateEligibilityTemplate = (rebateTypeId: number) => {
  return getRequest<BlobPart>(
    '/p2p-admin/service-fee-rebate/download/rebate-template',
    { rebateTypeId },
    {
      responseType: 'blob',
      acceptType: AcceptType.JSON,
      contentType: ContentType.JSON,
    },
  );
};

export const uploadRebateEligibilityExcel = (payload: FormData) => {
  return postRequest<investors.UploadRebateEligibilityResponse>(
    '/p2p-admin/service-fee-rebate/upload/rebate-eligibility-excel',
    payload,
  );
};

/* Investor Transaction Report */
export const getInvestorListDropdown = () => {
  return getRequest<CapBayApiData<Inputs.SelectOption[]>>(
    '/p2p-admin/investor-transaction-report/list-all-investors',
  );
};

export const getInvestorTransactionPresets = () => {
  return getRequest<CapBayApiData<investors.InvestorTransactionPreset[]>>(
    '/p2p-admin/investor-transaction-report/investor-presets',
  );
};

export const generateInvestorTransactionReport = (payload: investors.GetInvestorTransactionReportList) => {
  return postRequest<investors.GenerateInvestorTransactionReportResponse>(
    '/p2p-admin/investor-transaction-report/generate-report',
    payload,
  );
};

/* Sanction User */
export const getSanctionUserList = (payload: investors.SanctionListFilterData) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.SanctionUserData[]>>>(
    '/p2p-admin/sanction-user', payload,
  );
};

export const getMohaListDocument = () => {
  return getRequest<CapBayApiData<investors.GetMohaListDocumentResp>>(
    '/p2p-admin/sanction-user/moha-list-document',
  );
};

export const getSanctionCountriesList = () => {
  return getRequest<CapBayApiData<investors.GetSanctionCountriesListResp>>(
    '/p2p-admin/sanction-user/sanction-countries-list',
  );
};

export const recheckSanctionUser = (payload: investors.RecheckSanctionUserPayload) => {
  return postRequest<CapBayApiData<investors.RecheckSanctionUserResponse>>(
    '/p2p-admin/sanction-user/recheck', payload,
  );
};

export const postVerifySanctionUser = (payload: investors.VerifySanctionUserPayload) => {
  return postRequest<CapBayApiData<investors.VerifySanctionUserResponse>>(
    '/p2p-admin/sanction-user/verify', payload,
  );
};

export const getSanctionUserDetail = (payload: FormData) => {
  return postRequest<CapBayApiData<investors.InvestorDetails>>(
    '/p2p-admin/sanction-user/detail', payload,
  );
};

export const getSanctionUserAddress = (payload: FormData) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.AddressData[]>>>(
    '/p2p-admin/sanction-user/address', payload,
  );
};

export const getSanctionRemark = (payload: investors.GetRemarkDetailsParams) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.RemarkData[]>>>(
    '/p2p-admin/sanction-user/remark', payload,
  );
};

export const getSanctionMohaResponse = (payload: investors.GetMohaResponseParams) => {
  return postRequest<CapBayApiData<investors.MohaResponseData>>(
    '/p2p-admin/sanction-user/moha-response', payload,
  );
};

export const postAddSanctionRemark = (payload: investors.PostAddSanctionRemarkParam) => {
  return postRequest<CapBayApiData<investors.AddSanctionRemarkResponse>>(
    '/p2p-admin/sanction-user/remark/add', payload,
  );
};

export const getSanctionUserEkyc = (payload: FormData) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.SanctionEkycData[]>>>(
    '/p2p-admin/sanction-user/ekyc',
    payload,
  );
};

export const getSanctionUserDocuments = (payload: FormData) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.SanctionUserDocumentData[]>>>(
    '/p2p-admin/sanction-user/document',
    payload,
  );
};

export const postDownloadSanctionUserDocument = (payload: FormData) => {
  return postRequest<Blob>(
    '/p2p-admin/sanction-user/document/download',
    payload,
    {
      contentType: ContentType.JSON,
      acceptType: AcceptType.JSON,
      responseType: 'blob',
    },
  );
};

export const getIcrpQuestions = () => {
  return getRequest<CapBayApiData<investors.GetIcrpQuestions>>(
    '/p2p-admin/investor/icrp/questions',
  );
};

export const postLatestICRPDetails = (id: number) => {
  return postRequest<CapBayApiData<investors.PostICRPDetailsData>>(
    '/p2p-admin/investor/icrp/latest-details',
    { id },
  );
};

export const postICRPHistory = (id: number) => {
  return postRequest<CapBayApiData<CapBayTabularData<investors.GetICRPHistoryData[]>>>(
    '/p2p-admin/investor/icrp/history',
    { id },
  );
};

export const postDownloadICRPForm = (payload: FormData) => {
  return postRequest<Blob>('/p2p-admin/investor/icrp/download', payload, {
    responseType: 'blob',
    acceptType: AcceptType.JSON,
    contentType: ContentType.JSON,
  });
};

export const getICRPQuestionOptions = () => {
  return getRequest<CapBayApiData<investors.ICRPQuestionOptionsData[]>>(
    '/p2p-admin/investor/icrp/question-options',
  );
};

export const postEditInvestorICRPForm = (payload: investors.EditInvestorICRPFormPayload) => {
  return postRequest<CapBayApiData<investors.InvestorListData>>(
    '/p2p-admin/investor/icrp/create',
    payload,
  );
};

export const postDownloadCDDProfile = (payload: FormData) => {
  return postRequest<Blob>('/p2p-admin/investor/download-cdd-profile', payload, {
    acceptType: AcceptType.JSON,
    contentType: ContentType.JSON,
    responseType: 'blob',
  });
};
